import { render, staticRenderFns } from "./AddGuestPasses.vue?vue&type=template&id=4be0f76e&"
import script from "./AddGuestPasses.vue?vue&type=script&lang=ts&"
export * from "./AddGuestPasses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports